// Diversity (Uranus): a word whose length no other word of the play shares
// scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const diversity: AlignmentDef = {
  id: 'diversity',
  planet: 'uranus',
  name: 'Diversity',
  text: () => `Words whose length no other word shares score +${N.diversityPercent}%.`,
  wordPercent: (c, ctx) => {
    const n = c.nodes.length;
    const shared = ctx.constellations.some((other, i) => i !== c.index && other.nodes.length === n);
    return shared ? 0 : N.diversityPercent;
  },
};
